import { Box, makeStyles } from "@material-ui/core";
import { DsText } from "@mvp/design-system";
import React from "react";
import { PhoneNumber } from "../../PhoneNumber";
import { ContentTitle } from "./ContentTitle";
import { modalText } from "./modalText";

const useStyles = makeStyles((theme) => ({
  modalContent: {
    padding: "2.5rem !important",
  },
  modalPhoneWrapper: {
    display: "flex",
  },
  semiBoldFont: {
    fontWeight: 600,
  }
}));

export const OverSixtyFiveContent: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <ContentTitle text={modalText.callToComplete} />
      <Box className={classes.modalPhoneWrapper}>
        <DsText variant="body1">
          {modalText.over65.part1}
          <PhoneNumber variant="body1" phoneNumber={modalText.medicarePhoneNumber} />
          {modalText.thankYou}
        </DsText>
      </Box>
    </>
  );
};